export default __webpack_public_path__ + "static/media/options.985342f3.svg";